import { Col, Row, Container, Typography } from '@ag1/ui';
import { SanityKeyed, IngredientsList as IngredientsListProps } from 'types/studio/studio';
import { UnifiedButton, UnifiedButtonType } from 'shared/studio/UnifiedButton';
import { getSectionPaddingClasses } from 'shared/utils/getSectionPaddingClasses';
import clsx from 'clsx';
import { IngredientsListCard } from './IngredientsListCard/IngredientsListCard';
import CustomPortableText from '../PortableText/PortableText';
import styles from './IngredientsList.module.scss';
import { CommonSectionProps } from '../types';

const IngredientsList = ({
  _key: key,
  _type: sectionType,
  headline,
  text,
  cards,
  unifiedButton,
  padding
}: SanityKeyed<IngredientsListProps> & CommonSectionProps) => (
  <div className={clsx(getSectionPaddingClasses(styles, padding))}>
    <Container narrow id={key}>
      <Row>
        <Col span={{ xxs: 12, l: 4 }}>
          <Typography
            variant="headlineSans"
            size="2"
            component="div"
            noPadding
            className={styles.headline}
            color="black-new">
            <CustomPortableText value={headline} tag="h2" />
          </Typography>
          {text && (
            <Typography
              variant="subtitle"
              size="2"
              component="div"
              noPadding
              className={styles.text}
              color="black-new">
              <CustomPortableText value={text} />
            </Typography>
          )}
        </Col>
        <Col span={{ xxs: 12, l: 6 }} className={styles.colCards}>
          <Row className={styles.cards}>
            {cards.map((item) => (
              <Col key={item._key} span={{ xxs: 12, m: 6, l: 12 }}>
                <IngredientsListCard {...item} />
              </Col>
            ))}
          </Row>
          {unifiedButton?.switchButton && (
            <UnifiedButton
              unifiedButton={unifiedButton as UnifiedButtonType}
              sectionType={sectionType}
              className={styles.button}
              size="medium"
              theme="new"
            />
          )}
        </Col>
      </Row>
    </Container>
  </div>
);

export default IngredientsList;
